import React from "react";
import PerspectiveSettings from "./PerspectiveSettings";
import DepartmentSettings from "./DepartmentSettings";

function SectionHeading({ title, description }) {
  return (
    <div className="mb-4">
      <h2 className="text-base font-bold text-gray-900">{title}</h2>
      {description && <p className="mt-1 max-w-2xl text-sm text-gray-500">{description}</p>}
    </div>
  );
}

function AdminSettings() {
  return (
    <div className="max-w-4xl space-y-10 pb-10">
      <section>
        <SectionHeading
          title="Perspectives & objectives"
          description="Perspectives are the top-level risk categories, and each one groups the strategic objectives that risks are mapped against. Staff choose from these when entering a new risk."
        />
        <PerspectiveSettings />
      </section>

      <section>
        <SectionHeading
          title="Departments"
          description="Every user belongs to a department. Add departments here, then assign users to them from the Users page."
        />
        <DepartmentSettings />
      </section>
    </div>
  );
}

export default AdminSettings;
